var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { styled } from '@web/theme';
import { usePageEdit } from '../../../ModulePage';
import { Fab } from '../../../Button';
import { useBlock, useBlockEdit, blockEditActions } from '../../../ModuleBlock';
export var BlockTitle = memo(function (_a) {
    var _b, _c;
    var id = _a.id, props = __rest(_a, ["id"]);
    var block = useBlock(id).block;
    var pageEdit = usePageEdit().pageEdit;
    var _d = useBlockEdit(), blockEdit = _d.blockEdit, dispatchBlockEdit = _d.dispatchBlockEdit;
    var onChange = function (e) {
        var _a;
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), (_a = {}, _a[e.target.name] = "" + e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), _a))
        });
    };
    var useTitle = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b._title) !== undefined ? (_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c._title : (block === null || block === void 0 ? void 0 : block._title) || '';
    if (!pageEdit.enabled)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { type: "text", name: "_title", value: useTitle, onChange: onChange })));
});
var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex: auto;\n\tmargin: 0 .25em;\n\tbackground: transparent;\n\tcolor: inherit;\n\tborder: none;\n\toutline: none;\n\tmin-width: 90px;\n\t\n\t&:active,\n\t&:focus {\n\t\tbackground-color: rgba(255,255,255,.5);\n\t}\n"], ["\n\tdisplay: flex;\n\tflex: auto;\n\tmargin: 0 .25em;\n\tbackground: transparent;\n\tcolor: inherit;\n\tborder: none;\n\toutline: none;\n\tmin-width: 90px;\n\t\n\t&:active,\n\t&:focus {\n\t\tbackground-color: rgba(255,255,255,.5);\n\t}\n"])));
var Save = styled(Fab)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tposition: sticky;\n\tbottom: 300px;\n"], ["\n\tmargin-left: auto;\n\tposition: sticky;\n\tbottom: 300px;\n"])));
var templateObject_1, templateObject_2;
